module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_5.c19e3797.jpg";